import Marquee from "react-fast-marquee";
import { CATEGORIES } from "@/lib/site";

const PHRASES = ["Curated stops only", "Ride · Sip · Savor", "Approved by locals", "Worth the detour"];

export default function EditorialMarquee() {
  const items = [];
  const max = Math.max(CATEGORIES.length, PHRASES.length);
  for (let i = 0; i < max; i++) {
    if (CATEGORIES[i]) items.push({ type: "cat", ...CATEGORIES[i] });
    if (PHRASES[i]) items.push({ type: "phrase", label: PHRASES[i] });
  }

  return (
    <div data-testid="editorial-marquee" className="relative z-10 overflow-hidden">
      <Marquee
        speed={24}
        gradient={false}
        pauseOnHover
        className="border-y border-[#154234]/10 bg-[#154234] py-4"
      >
        {items.map((item, i) => (
          <span
            key={i}
            className="mx-7 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-[#F4F7F4]/85"
          >
            {item.type === "cat" && <item.icon size={15} className="text-[#E05A47]" />}
            {item.label}
            <span className="ml-7 text-[#E05A47]">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
